import {createAction, props} from '@ngrx/store';
import AudioTrackModel from '../../../../../models/audio-track.model';

export const SetAudioTrackIsLoaded = createAction('[Audio] - Set Audio Track Is Loaded',
    props<{ isLoaded: boolean, audioTrackId: string }>()
);
export const SetAudioTrackIsPlaying = createAction('[Audio] - Set Audio Track Is Loaded',
    props<{ isPlaying: boolean, audioTrackId: string }>()
);
